module.exports = __webpack_public_path__ + "images/team-onboarding/powerups.c776f90022e425859b6f.jpg";